var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon trash-can",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.225.553A1 1 0 0 1 5.119 0h3.762a1 1 0 0 1 .894.553L10 1h3a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h3zM.972 4H13v10a2 2 0 0 1-2 2H2.972a2.019 2.019 0 0 1-2-2zm2.5 2.5v7a.521.521 0 0 0 .5.5.484.484 0 0 0 .5-.5v-7a.484.484 0 0 0-.5-.5.521.521 0 0 0-.5.5zm3 0v7a.521.521 0 0 0 .5.5.508.508 0 0 0 .528-.5v-7a.508.508 0 0 0-.528-.5.521.521 0 0 0-.5.5zm3.028 0v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.88dadadc3f8c59bc4860d943eba9c79a.svg";
export { ForwardRef as ReactComponent };